"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _invoices = require("@module/invoices");

var _app = require("@package/app");

var _dialog = require("@package/dialog");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _ApplyForm = _interopRequireDefault(require("./ApplyForm"));

var _excluded = ["data"];

function ApplyProcess(_ref) {
  var data = _ref.data,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  try {
    var handleReset = function handleReset() {
      dispatch((0, _dialog.closeDialog)("invoice-apply"));
    };

    var handleSubmit = function handleSubmit(formData) {
      dispatch((0, _invoices.createAuthorize)({
        id: data['id'],
        amount: Number(formData['amount'])
      }));
      dispatch((0, _dialog.closeDialog)("invoice-apply"));
    };

    var dispatch = (0, _reactRedux.useDispatch)();
    return /*#__PURE__*/_react["default"].createElement(_ApplyForm["default"], Object.assign({}, props, {
      initialValues: {
        amount: data['amount'],
        finalAmount: data['amount']
      },
      onReset: handleReset,
      onSubmit: handleSubmit
    }));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = ApplyProcess;
exports["default"] = _default;